import { ClayButton } from "./ClayButton";
import { ClayInput } from "./ClayInput";
import { cx } from "../lib/cx";
import { daysAgoIso, startOfMonthIso, todayIso } from "../lib/format";

export interface DateRange {
  from: string;
  to: string;
}

export interface DateRangePickerProps {
  value: DateRange;
  onChange: (next: DateRange) => void;
  className?: string;
  showPresets?: boolean;
}

export function DateRangePicker({
  value,
  onChange,
  className,
  showPresets = true,
}: DateRangePickerProps) {
  const presets: Array<{ label: string; range: DateRange }> = [
    { label: "7 hari", range: { from: daysAgoIso(6), to: todayIso() } },
    { label: "30 hari", range: { from: daysAgoIso(29), to: todayIso() } },
    { label: "Bulan ini", range: { from: startOfMonthIso(), to: todayIso() } },
  ];

  return (
    <div className={cx("flex flex-col gap-3", className)}>
      <div className="grid gap-3 sm:grid-cols-2">
        <ClayInput
          label="Dari tanggal"
          type="date"
          value={value.from}
          onValueChange={(from) => onChange({ ...value, from })}
        />
        <ClayInput
          label="Sampai tanggal"
          type="date"
          value={value.to}
          onValueChange={(to) => onChange({ ...value, to })}
        />
      </div>

      {showPresets ? (
        <div className="flex flex-wrap items-center gap-2">
          {presets.map((preset) => {
            const active = value.from === preset.range.from && value.to === preset.range.to;
            return (
              <ClayButton
                key={preset.label}
                variant={active ? "primary" : "secondary"}
                size="sm"
                onClick={() => onChange(preset.range)}
              >
                {preset.label}
              </ClayButton>
            );
          })}
          <ClayButton
            variant="ghost"
            size="sm"
            disabled={!value.from && !value.to}
            onClick={() => onChange({ from: "", to: "" })}
          >
            Semua tanggal
          </ClayButton>
        </div>
      ) : null}
    </div>
  );
}
